<template>
  <g transform="translate(0 0.188)">
    <g transform="translate(0 -0.33)">
      <rect
        width="24"
        height="24"
        transform="translate(0 0.143)"
        fill="none"
      />
    </g>
    <g transform="translate(1 1)">
      <g transform="translate(9.787 5.57)">
        <rect
          width="9"
          height="11"
          transform="translate(0.213 0.243)"
          fill="#c7f2ff"
        />
      </g>
      <g transform="translate(1 3.813)">
        <path
          d="M18.452,4.936A10.3,10.3,0,0,0,15.4,4.5a8.115,8.115,0,0,0-4.8,1.309A8.116,8.116,0,0,0,5.8,4.5,8.116,8.116,0,0,0,1,5.809V18.593a.469.469,0,0,0,.436.436c.087,0,.131-.044.218-.044a10.65,10.65,0,0,1,4.145-.96,8.115,8.115,0,0,1,4.8,1.309,10.511,10.511,0,0,1,4.8-1.309,8.882,8.882,0,0,1,4.145.916.393.393,0,0,0,.218.044.469.469,0,0,0,.436-.436V5.809A5.952,5.952,0,0,0,18.452,4.936Zm0,11.78A10.14,10.14,0,0,0,15.4,16.28a10.511,10.511,0,0,0-4.8,1.309V7.554a10.511,10.511,0,0,1,4.8-1.309,10.14,10.14,0,0,1,3.054.436Z"
          transform="translate(-1 -4.5)"
          fill="#3ba7c7"
        />
        <g transform="translate(10.471 3.927)">
          <path
            d="M16.927,10.309a10.2,10.2,0,0,1,2.182.227V9.209A11.783,11.783,0,0,0,16.927,9,10.041,10.041,0,0,0,13,9.724v1.449A8.1,8.1,0,0,1,16.927,10.309Z"
            transform="translate(-13 -9)"
            fill="#3ba7c7"
          />
          <path
            d="M13,12.384v1.449a8.1,8.1,0,0,1,3.927-.864,10.2,10.2,0,0,1,2.182.227V11.869a11.783,11.783,0,0,0-2.182-.209A10.2,10.2,0,0,0,13,12.384Z"
            transform="translate(-13 -9.339)"
            fill="#3ba7c7"
          />
          <path
            d="M16.927,14.33A10.041,10.041,0,0,0,13,15.054V16.5a8.1,8.1,0,0,1,3.927-.864,10.2,10.2,0,0,1,2.182.227V14.539A11.079,11.079,0,0,0,16.927,14.33Z"
            transform="translate(-13 -9.679)"
            fill="#3ba7c7"
          />
        </g>
      </g>
    </g>
  </g>
</template>
